import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Suspense } from 'react';
import { Provider } from 'react-redux';

import FuelErrorBoundary from './components/FuelErrorBoundary/FuelErrorBoundary';
import AppResourcesProvider from './contexts/AppResourcesProvider';
import AuthProvider from './contexts/AuthContext';
import GlobalDataProvider from './contexts/GlobalDataProvider';
import LDProvider from './contexts/LDProvider';
import LoadingProvider from './contexts/LoadingProvider';
import ProgressProvider from './contexts/ProgressProvider';
import TitleProvider from './contexts/TitleContext';
import { WebSocketProvider } from './contexts/WebSocketProvider';
import store from './store';
import ThemeModeProvider from './themes/ThemeModeProvider';

const Providers = () => {
  return (
    <Suspense fallback={null}>
      <ThemeModeProvider>
        <FuelErrorBoundary>
          <LoadingProvider>
            <Provider store={store}>
              <ProgressProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <TitleProvider>
                    <AuthProvider>
                      <GlobalDataProvider>
                        <AppResourcesProvider>
                          <WebSocketProvider>
                            <LDProvider />
                          </WebSocketProvider>
                        </AppResourcesProvider>
                      </GlobalDataProvider>
                    </AuthProvider>
                  </TitleProvider>
                </LocalizationProvider>
              </ProgressProvider>
            </Provider>
          </LoadingProvider>
        </FuelErrorBoundary>
      </ThemeModeProvider>
    </Suspense>
  );
};

export default Providers;
